<!-- @format -->

<faq-tag>
<div class="contents contents-wide">
  <section class="contents_area">
    <div class="container_heading">
      <h1 class="heading-01 heading_faq">よくあるご質問</h1>
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><a href="/menu" class="home">ホーム</a></li>
        <li class="breadcrumb-item">よくあるご質問</li>
      </ul>
    </div><!--/.container_heading-->
    

      <div class="contents_block">
        <faq-content-tag></faq-content-tag>
      </div><!--/.contents_block-->

      
  </section><!--/.contents_area-->
</div><!--/.contents-->


<script>
  import faqTag from '@tags/parts/editech-hub-faq.riot';
  export default {
    components: {
      "faq-content-tag": faqTag
    }
  }
</script>
</faq-tag>
